var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { transient, autoinject } from "aurelia-framework";
import { BaseTemplate } from "../../templates/base-template";
import { Router } from "aurelia-router";
import { ClientLotteryClientService } from "../../../../services/modules/client/client-lottery-client-service";
import { I18N } from "aurelia-i18n";
import { DialogClientService } from "../../../../services/basics/dialog-client.service";
import { TokenClient } from "../../../../services/authentication/token-client.service";
import { BrandClientService, TemplateType } from "../../../../services/modules/brand-client.service";
import { LookupClientService } from "../../../../services/lookups/lookup-client.service";
import { LookupValueRequest, LookupValueQuery } from "../../../../models/lookups/lookup.models";
import { WidgetNames } from "../../../../models/modules/lotteryplatofrm.models";
import { ConfigClientService } from "../../../../services/modules/client-config.service";
var StandardWidget2 = /** @class */ (function (_super) {
    __extends(StandardWidget2, _super);
    function StandardWidget2(router, lotteryClientService, i18N, dialogClientService, tokenClient, brandClientService, lookupClientService, configClientService) {
        var _this = _super.call(this, router, i18N, lotteryClientService, dialogClientService, tokenClient) || this;
        _this.brandClientService = brandClientService;
        _this.configClientService = configClientService;
        _this.defaultUserCurrencySymbol = tokenClient.getUserCurrency().symbol;
        var request = new LookupValueRequest();
        request.lookupValueQuery = LookupValueQuery.lotteryWidgets;
        lookupClientService.getLookup(request).then(function (x) {
            _this.currentWidgetId = x.values.filter(function (a) { return a.additionalData.internalName == WidgetNames.StandardWidget2; })[0].id;
        });
        return _this;
    }
    StandardWidget2.prototype.attached = function () {
        return __awaiter(this, void 0, void 0, function () {
            var assests, key;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _super.prototype.attached.call(this);
                        return [4 /*yield*/, this.configClientService.getClientConfig(TemplateType.Assets)];
                    case 1:
                        assests = _a.sent();
                        key = this.model.isLottery ? this.getLotteryKey(this.model.currentLottery.lotteryName) :
                            this.model.isBundle ? this.getBundleKey(this.model.currentBundle.name) : "";
                        this.buttonsRounded = assests[TemplateType.Assets].filter(function (x) { return x.key == key; })[0][TemplateType.Template]["buttons"]["rounded"];
                        return [2 /*return*/];
                }
            });
        });
    };
    StandardWidget2.prototype.record = function (lottery) {
        var link = this.i18n.tr("".concat(lottery, "-navigation-url"));
        this.brandClientService.recordAffiliateLink({
            referer: document.referrer,
            redirectedTo: link,
            lotteryWidgetId: this.currentWidgetId
        });
        return true;
    };
    StandardWidget2.prototype.activate = function (params) {
        this.model = params;
        return null;
    };
    StandardWidget2 = __decorate([
        autoinject,
        transient(),
        __metadata("design:paramtypes", [Router, ClientLotteryClientService, I18N, DialogClientService, TokenClient,
            BrandClientService, LookupClientService, ConfigClientService])
    ], StandardWidget2);
    return StandardWidget2;
}(BaseTemplate));
export { StandardWidget2 };
